import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { NRIconComponent } from '@shared/components/nr-icon/nr-icon.component';
import currentFeatures from 'src/app/components/home-page/current-features.json';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'current-features',
  imports: [NRIconComponent, CommonModule],
  templateUrl: './current-features.component.html',
  styleUrl: './current-features.component.scss',
})
export class CurrentFeaturesComponent implements OnInit {
  features = [];
  isAdmin = false;
  private readonly authService = inject(AuthService);
  constructor(private readonly router: Router, ) {}

  ngOnInit() {
    this.authService.isAdmin$?.subscribe((isAdmin) => {
      this.isAdmin = !!isAdmin;
      this.features = this.isAdmin
        ? currentFeatures
        : currentFeatures.map(ob =>
          ob.name === 'Configuration' ? { ...ob, disabled: true } : ob
        );
    });
  } 

  navigateToFeature(route: string) {
    this.router?.navigate([route]);
  }
}
